import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SaleList, { SearchFormData } from '../../appStore/actions/saleList';
import PromotionList from './PromotionList';
import './style.css';

const TAB_ROUTES = {
    loyalty: '/promotions/loyalty',
    sales: '/promotions/sales',
    airline: '/promotions/airline',
};

const Promotion = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const activeTab = location.pathname.includes('/promotions/sales')
        ? 'sales'
        : location.pathname.includes('/promotions/airline')
            ? 'airline'
            : 'loyalty';

    const handleTabSelect = (key) => {
        if (!key || key === activeTab) return;
        dispatch(SaleList([]));
        dispatch(SearchFormData({}));
        history.push(TAB_ROUTES[key] || TAB_ROUTES.loyalty);
    };

    return (
        <div>
            <div className="cm-head-2">
                <div className="d-flex justify-content-between">
                    <span>Promotion</span>
                </div>
            </div>
            <Tabs
                activeKey={activeTab}
                onSelect={handleTabSelect}
                transition={false}
                className="cm-nav-tabs mt-3"
                mountOnEnter
                unmountOnExit
            >
                <Tab eventKey="loyalty" title="Loyalty Promotion">
                    <PromotionList promotionType="loyalty" />
                </Tab>
                <Tab eventKey="sales" title="Sales Promotion">
                    <PromotionList promotionType="sales" />
                </Tab>
                <Tab eventKey="airline" title="Airline Promotion">
                    <PromotionList promotionType="airline" />
                </Tab>
            </Tabs>
        </div>
    );
};

export default Promotion;
